import styled from 'styled-components'
import {
  BaseText,
  BoldText,
  MediumText,
  SemiBoldText,
  SmallText,
} from 'components/common/text'
import { Column } from 'components/common/layout'
import { Button } from 'components/common/button'
import { Card } from 'components/common/card'

export const ContentsContainer = styled(Column)`
  @media ${(p) => p.theme.deviceSize.desktop} {
    width: 500px;
    margin: auto;
  }
  height: 100dvh;
  overflow: scroll;
  justify-content: flex-start;
  box-shadow: 0px 4px 40px 0px rgba(0, 0, 0, 0.1);
  background-color: ${(p) => p.theme.color.white1};
`

export const ContentsWrapper = styled(Column)`
  gap: 80px;
  text-align: center;
  padding: 80px 24px 100px;
`

export const ContentsSubDescText = styled(BaseText)`
  color: ${(p) => p.theme.color.black3};
  line-height: 1.6;
`

export const ContentsSubInputText = styled(BoldText)`
  font-size: 14px;
`

export const ContentsBtn = styled(Button)`
  padding: 16px 0;
  border-radius: 16px;
`

export const BoldH2Text = styled(BoldText)`
  font-size: ${(p) => p.theme.fontSize.h2};
`

export const MediumDescText = styled(MediumText)`
  font-size: ${(p) => p.theme.fontSize.desc};
`

export const SemiBold14Text = styled(SemiBoldText)`
  font-size: 14px;
`

export const ChipText = styled(MediumText)`
  padding: 8px 12px;
  border-radius: 16px;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.08);
  border: 1px solid ${(p) => p.theme.color.line};
  background-color: ${(p) => p.theme.color.white1};
`

export const SemiBoldH5Text = styled(SemiBoldText)`
  font-size: ${(p) => p.theme.fontSize.h5};
`

export const ContentsCard = styled(Card)`
  gap: 10px;
  padding: 20px;
  position: relative;
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.25);
`

export const ContentsGuideCard = styled(Card)`
  padding: 8px;
  border-radius: 8px;
  background-color: ${(p) => p.theme.color.background2};
`

export const ContentsGuideText = styled(SmallText)`
  line-height: 1.4;
  color: ${(p) => p.theme.color.gray1};
`

export const ContentDescText = styled(BaseText)`
  line-height: 1.8;
`
